// src/component/Account/Sidebar.jsx
import React from "react";
import { useAuth } from "../../context/AuthContext";
import { NavLink } from "react-router-dom";
import { AvatarSkel } from "./skeletons";
import avatarImg from "../../images/avatar.png";
export default function Sidebar({ loading, profile }) {
  const { logout } = useAuth();
const imgSrc = profile?.avatarUrl || avatarImg;
  return (
    <aside className="acc-sidebar">
      <div className="acc-card">
        <div className="acc-avatarWrap">
          {loading ? <AvatarSkel/> : (
             <img
              src={imgSrc}
              alt={profile?.name || "Avatar"}
              className="acc-avatar"
              onError={(e) => { e.currentTarget.src = avatarImg; }}
            />
          )}
         
        </div>
        <div className="acc-name">{loading ? "…" : (profile?.name || "Mon compte")}</div>
      </div>

      <nav className="acc-menu" aria-label="Menu compte">
        <NavLink to="/account" end className="acc-link">Compte</NavLink>
        <NavLink to="/account/orders" className="acc-link">Ordres</NavLink>
       
       
        <NavLink to="/account/wishlist" className="acc-link">Liste de souhaits</NavLink>
        <button className="acc-link acc-logout" onClick={logout}>Déconnexion</button>
      </nav>
    </aside>
  );
}
